module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/heavyTank-prem-tiny.b457d4d8.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/heavyTank-prem-tiny.png
// module id = 2717
// module chunks = 11